import React from "react";
import "./Empower.css";
import BorekLogo from "../../assets/borek-logo-dark 1.png.webp";
import MaxLuukLogo from "../../assets/max&luuk-dark 1.png.webp";
import YoiLogo from "../../assets/logo-yoi-1707815081 1.png.webp";

const Empower: React.FC = () => {
  return (
    <section className="empower-section">
      {/* Shared container matching navbar and hero */}
      <div className="empower-container">
        <div className="empower-header">
          <h2>
            About <span>Bixton Lighting</span>
          </h2>
          <div className="empower-underline"></div>
        </div>

        <div className="empower-content">
          <p className="empower-description">
          We are a fast growing lighting company specializing in the marketing of lighting products under our own brand Bixton and international brands. It is the philosophy of the company to ensure the best products are offered at the right price. Therefore, we take utmost care to ensure that the products we market.
            <br />
            <br />
            Meets the highest quality and safety standards. To ensure this we only source products from reputed companies/factories in the world which ensure proper quality standards. Apart from this, most products imported into the country is subject to testing at government approved laboratories in Sri Lanka to ensure it complies with the local standards.

            <br />
            <br />
            Our differentiating factor is our manpower, who, has extensive industry knowledge and experience having acquired from working with large international and local lighting companies.The team is versed with market dynamics and ensures an efficient and a friendly service to all customers.

          </p>
        </div>
      </div>
    </section>
  );
};

export default Empower;
